import _ from 'lodash';
import moment from 'moment';

require('moment/locale/pt-br.js');
moment.locale('pt-br');

export const momentMixin = {
  methods: {
    moment(date = new Date(), format) {
      return format ? moment(date, format) : moment(date);
    },
    formatDate(date = new Date(), format = 'L') {
      return moment(date).format(format);
    },
    formatTime(time) {
      time = _.isNumber(time) ? time : time.value;
      if (!time) {
        return '';
      }

      // Hours, minutes and seconds
      const hrs = ~~(time / 3600);
      const mins = ~~((time % 3600) / 60);
      const secs = time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      let response = '';

      if (hrs > 0) {
        response += `${hrs < 10 ? `0${hrs}` : hrs}:${mins < 10 ? '0' : ''}`;
      } else {
        response += `00:${mins < 10 ? '0' : ''}`;
      }

      response += '' + mins + ':' + (secs < 10 ? '0' : '');
      response += '' + secs;
      return response;
    },
    toDate(date = new Date(), format = 'L') {
      return moment(date, format).toDate();
    }
  }
};
